import React from 'react';
import { useSelector } from 'react-redux';
import { fa_number } from '../../utils/PersianNum';

const CartIcon = ({showCart}) => {
  const cart = useSelector((state) => state.cart.cart);

  // Calculate total items in the cart
  const totalItems = cart.reduce((total, product) => total + product.quantity, 0);

  if(totalItems > 0) return (
    <button type='button' className="cart-icon-container" onClick={() => showCart(true)}>
        <span className="fa fa-shopping-cart me-2"></span>
        <p className='d-inline'>Shopping Cart</p>
        <span className="cart-item-count">{fa_number(+totalItems)}</span>
    </button>
  );
};

export default CartIcon;